import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';

import Head from '../../helper/Head';
import ShowImage from '../../components/ShowImage/ShowImage';
import { telefoneMascara, dataBr, cpfMascara } from '../../util/mascaras';
import formularioPeticaoService from './service/formularioPeticao.service';
import styles from './ResumoFormularioPeticao.module.css';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CheckCircle from '@mui/icons-material/CheckCircle';
import PauseCircleIcon from '@mui/icons-material/PauseCircle';
import { Button, Card, CardContent, Checkbox, FormControl, FormControlLabel, FormHelperText, FormLabel, Link, Radio, RadioGroup, TextField } from '@mui/material';
import { objVazio } from '../../util/util';
import { FileText } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';

const ResumoFormularioPeticao = () => {

    const location = useLocation();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [registroDenuncia, setRegistroDenuncia] = useState('');
    const [fotosDenuncia, setFotosDenuncia] = useState([] as any);
    const [selectedImage, setSelectedImage] = useState();
    const [showImage, setShowImage] = useState(false);
    const [grupoTrabalhoList, setGrupoTrabalhoList] = useState([] as any);
    const [grupoTrabalhoOutros, setGrupoTrabalhoOutros] = useState(false);

    const [logStatus, setLogStatus] = useState([] as any);
    const { register, handleSubmit, watch, setValue, formState: { errors } } = useForm();

    useEffect(() => {
        const registroDenuncia = (location.pathname.split('/')[4] + "/" + location.pathname.split('/')[5]) ?? '';

        if (registroDenuncia !== '/undefined') {
            (async () => {
                const resp = await formularioPeticaoService.getNumeroRegistroFormularioPeticao(registroDenuncia);
                if (!!resp.formularioPeticao) {
                    const arquivos: any[] = [];
                    if (resp.formularioPeticao.srcArquivosPeticao) {
                        resp.formularioPeticao.srcArquivosPeticao.forEach((e: any) => {
                            const isArquivo = (e.includes('.pdf') || e.includes('.doc') || e.includes('.mp4') || e.includes('.wmv') || e.includes('.avi')) ? true : false

                            arquivos.push({
                                arquivo: e,
                                docOuPdf: isArquivo
                            })
                        })
                    }

                    setFotosDenuncia(arquivos);
                    setLogStatus(resp.formularioPeticao.status);

                    setRegistroDenuncia(resp.formularioPeticao.registroDenuncia);
                    setValue('statusDenuncia', resp.formularioPeticao.statusAtual);
                    setValue('idFormularioPeticao', resp.formularioPeticao.idFormularioPeticao);
                    setValue('registroDenuncia', resp.formularioPeticao.registroDenuncia);
                    setValue('nome', resp.formularioPeticao.nome);
                    //setValue('cpf', cpfMascara(resp.formularioPeticao.cpf)); //aqui
                    setValue('documentoPessoal', resp.formularioPeticao.documentoPessoal);
                    //setValue('apelido', resp.formularioPeticao.apelido); //aqui
                    setValue('nomeSocial', resp.formularioPeticao.nomeSocial);
                    //setValue('sexo', resp.formularioPeticao.sexo); //aqui
                    setValue('genero', resp.formularioPeticao.genero);
                    setValue('telefone', telefoneMascara(resp.formularioPeticao.telefone));
                    setValue('email', resp.formularioPeticao.email);
                    setValue('estadoUsuario', resp.formularioPeticao.estadoUsuario);
                    setValue('cidadeUsuario', resp.formularioPeticao.cidadeUsuario);
                    setValue('endereco', resp.formularioPeticao.endereco);
                    setValue('fato', resp.formularioPeticao.fato);
                    setValue('pedido', resp.formularioPeticao.pedido);
                    //setValue('dataEvento', dataBr(resp.formularioPeticao.dataEvento)); //aqui
                    setValue('dataViolacao', dataBr(resp.formularioPeticao.dataViolacao));
                    setValue('estadoOcorrencia', resp.formularioPeticao.estadoOcorrencia);
                    setValue('cidadeOcorrencia', resp.formularioPeticao.cidadeOcorrencia);
                    setValue('contatoEnvolvido', resp.formularioPeticao.contatoEnvolvido);
                    setValue('estadoMembro', resp.formularioPeticao.estadoMembro);

                    const data = await formularioPeticaoService.getGrupoTrabalho();
                    const grupoTrabalhos: any[] = []

                    data.forEach((e: any, i: any) => {
                        let grupoTrabalho = {};
                        resp.formularioPeticao.grupo_trabalho_dados.forEach((e1: any) => {
                            if (parseInt(e.idGrupoTrabalho) == parseInt(e1.idGrupoTrabalho)) {
                                grupoTrabalho = {
                                    idGrupoTrabalho: e.idGrupoTrabalho,
                                    atividade: e.atividade,
                                    checked: true
                                };

                                if (e1.outros !== null) {
                                    setGrupoTrabalhoOutros(true);
                                    setValue('grupoTrabalhoOutros', e1.outros);
                                }

                            }
                        });

                        if (!objVazio(grupoTrabalho)) {
                            grupoTrabalhos.push(grupoTrabalho)
                        } else {
                            grupoTrabalhos.push({
                                idAtividadeGarimpo: e.idAtividadeGarimpo,
                                atividade: e.atividade,
                                checked: false
                            });
                        }
                    });
                    setGrupoTrabalhoList(grupoTrabalhos);
                }

            })()
        }
    }, [])

    function handleOpenPhotoFullWidth(e: any) {
        setSelectedImage(e.target);
        setShowImage(true);
    }


    return (
        <section className="background-section background-full">
            <Head title=" | Resumo petição" />
            <div className={`animeRight ${styles.container}`}>
                <div className={styles.formContainer}>
                    <Card>
                        <CardContent>
                            <span className={styles.formDescription}>
                                {t('textoNumeroRegistroPeticao')} {registroDenuncia}
                            </span>
                            <div>
                                <div className={styles.grid}>
                                    <TextField
                                        {...register('registroDenuncia', { required: false })}
                                        className='mb-2 w-100'
                                        label={t('registroDenuncia')}
                                        variant="outlined"
                                        type='text'
                                        inputProps={{ readOnly: true }}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                    <TextField
                                        {...register('nome', { required: false })}
                                        className='mb-2 w-100'
                                        label={t('nome')}
                                        variant="outlined"
                                        type='text'
                                        inputProps={{ readOnly: true }}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                    <TextField
                                        {...register('documentoPessoal', { required: false })}
                                        className='mb-2 w-100'
                                        label={t('documentoPessoal')}
                                        variant="outlined"
                                        type='text'
                                        inputProps={{ readOnly: true }}
                                        InputLabelProps={{ shrink: true }}
                                        error={errors.estado ? true : false}
                                        helperText={errors.estado && 'Campo de estado esta vazio!'}
                                    />
                                    <TextField
                                        {...register('nomeSocial', { required: false })}
                                        className='mb-2 w-100'
                                        label={t('nomeSocial')}
                                        variant="outlined"
                                        type='text'
                                        inputProps={{ readOnly: true }}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                    <TextField
                                        className='mb-2 w-100'
                                        {...register('genero', { required: false })}
                                        label={t('genero')}
                                        inputProps={{ readOnly: true }}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                    <TextField
                                        className='mb-2 w-100'
                                        {...register('telefone', { required: false })}
                                        label={t('telefone')}
                                        inputProps={{ readOnly: true }}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                    <TextField
                                        className='mb-2 w-100'
                                        {...register('email', { required: false })}
                                        label={t('email')}
                                        inputProps={{ readOnly: true }}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                    <TextField
                                        className='mb-2 w-100'
                                        {...register('estadoMembro', { required: false })}
                                        label={t('estadoMembro')}
                                        inputProps={{ readOnly: true }}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                    <TextField
                                        className='mb-2 w-100'
                                        {...register('estadoUsuario', { required: false })}
                                        label={t('estadoUsuario')}
                                        inputProps={{ readOnly: true }}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                    <TextField
                                        className='mb-2 w-100'
                                        {...register('cidadeUsuario', { required: false })}
                                        label={t('cidadeUsuario')}
                                        inputProps={{ readOnly: true }}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                    <TextField
                                        className='mb-2 w-100'
                                        {...register('endereco', { required: false })}
                                        label={t('endereco')}
                                        inputProps={{ readOnly: true }}
                                        InputLabelProps={{ shrink: true }}
                                    />

                                </div>
                                <div className={styles.grid1}>
                                    <FormControl >
                                        <FormLabel>
                                            {t('textoTema')}
                                        </FormLabel>

                                        <div className='col'>
                                            {grupoTrabalhoList.length > 0 &&
                                                <>
                                                    {grupoTrabalhoList.map((e: any, i: any) => (

                                                        <div key={i}>
                                                            <FormControlLabel
                                                                {...register(`grupoTrabalho`, { required: false })}
                                                                control={<Checkbox
                                                                    disabled
                                                                    checked={e.checked}
                                                                    style={{ color: errors.grupoTrabalho ? 'red' : '' }}
                                                                />}
                                                                label={''}
                                                            />
                                                            {<span style={{ color: errors.grupoTrabalho ? 'red' : '' }}>
                                                                {e.atividade}
                                                            </span>
                                                            }
                                                        </div>
                                                    ))}

                                                    {(grupoTrabalhoOutros) &&
                                                        <TextField
                                                            {...register('grupoTrabalhoOutros', { required: true })}
                                                            label={t('grupoTrabalhoOutros')}
                                                            className='mb-3 w-100'
                                                            variant="outlined"
                                                            type='text'
                                                            InputLabelProps={{ shrink: true }}
                                                            inputProps={{ readOnly: true }}
                                                        />
                                                    }

                                                </>
                                            }
                                        </div>
                                    </FormControl>

                                    <div className={styles.textAreaResume}>
                                        <TextField
                                            {...register('fato', { required: false })}
                                            className='mb-2 w-100'
                                            label={t('fato')}
                                            variant="outlined"
                                            type='text'
                                            inputProps={{ readOnly: true }}
                                            InputLabelProps={{ shrink: true }}
                                            multiline rows={10}
                                            error={errors.situacaoDescrita ? true : false}
                                            helperText={errors.situacaoDescrita && 'Campo de Descreva a situação esta vazio!'}
                                        />
                                        <TextField
                                            {...register('pedido', { required: false })}
                                            className='mb-2 w-100'
                                            label={t('pedido')}
                                            variant="outlined"
                                            type='text'
                                            inputProps={{ readOnly: true }}
                                            InputLabelProps={{ shrink: true }}
                                            multiline rows={10}
                                            error={errors.situacaoDescrita ? true : false}
                                            helperText={errors.situacaoDescrita && 'Campo de Descreva a situação esta vazio!'}
                                        />
                                    </div>
                                </div>
                                <div className={styles.row1}>
                                    <TextField
                                        className='mb-2 w-100'
                                        {...register('dataViolacao', { required: false })}
                                        label={t('dataViolacao')}
                                        inputProps={{ readOnly: true }}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                    <TextField
                                        className='mb-2 w-100'
                                        {...register('estadoOcorrencia', { required: false })}
                                        label={t('estadoOcorrencia')}
                                        inputProps={{ readOnly: true }}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                    <TextField
                                        className='mb-2 w-100'
                                        {...register('cidadeOcorrencia', { required: false })}
                                        label={t('cidadeOcorrencia')}
                                        inputProps={{ readOnly: true }}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                    <TextField
                                        {...register('contatoEnvolvido', { required: false })}
                                        className='mb-2 w-100'
                                        label={t('contatoEnvolvido')}
                                        variant="outlined"
                                        type='text'
                                        inputProps={{ readOnly: true }}
                                        InputLabelProps={{ shrink: true }}
                                        error={errors.contatoEnvolvido ? true : false}
                                        helperText={errors.contatoEnvolvido && 'Campo de Contato esta vazio!'}
                                    />
                                    
                                </div>

                            </div>

                            <div className={styles.anexo}>
                                <div className={styles.anexoHead}>
                                    <span className={styles.anexoTitle}>
                                        {t('textoArquivosAnexados')}
                                    </span>
                                </div>
                                {fotosDenuncia.length > 0 ?
                                    <div className={styles.fotoAnexadas}>
                                        {
                                            fotosDenuncia.map((foto: any, index: any) => (
                                                <div key={index}>
                                                    {foto.docOuPdf ?
                                                        <Link target='_blank' href={foto.arquivo}>
                                                            <FileText size={28} color="#030303" weight="duotone" />
                                                            Arquivo {index + 1}
                                                        </Link>
                                                        :
                                                        <img key={index} onClick={handleOpenPhotoFullWidth} src={foto.arquivo} title="Arquivo" alt="Arquivo" />
                                                    }

                                                </div>
                                            ))
                                        }
                                    </div>
                                    :
                                    <p className={styles.semArquivos}>
                                        {t('msgNaoHaArquivosAnexados')}
                                    </p>
                                }
                            </div>

                            <div className={styles.statusTable}>
                                <table>
                                    <thead>
                                        <tr>
                                            <th colSpan={3}>
                                                {t('textoStatusPeticao')}
                                            </th>
                                        </tr>
                                        <tr className={styles.statusHead}>
                                            <th><span>{t('textoEtapa')}</span></th>
                                            <th><span>{t('textoIniciadoEm')}</span></th>
                                            <th><span>{t('textoComentarios')}</span></th>
                                        </tr>
                                    </thead>
                                    <tbody className={styles.statusList}>
                                    {
                                            logStatus.map((item : any, index : any) => (
                                                <tr key={index} className={styles.statusItem}>
                                                    <td>
                                                        <CheckCircle sx={{ fontSize: 25, color: 'green' }} />
                                                        <span>{item.status_denuncia_name + ' - ' + item.status_acompanhamento_name}</span>
                                                    </td>
                                                    <td>{item.criado_em}</td>
                                                    <td>{item.comentarios}</td>
                                                </tr>
                                            ))
                                        }

                                    </tbody>
                                </table>
                            </div>

                            <div className={styles.formButton}>
                                <Button onClick={() => navigate(-1)}>
                                    <ArrowBackIcon sx={{ fontSize: 30 }} />
                                </Button>
                            </div>
                        </CardContent>
                    </Card>
                </div>
            </div>

            <ShowImage
                showingImage={showImage}
                setShowImage={setShowImage}
                image={selectedImage}
            />
        </section>
    )
}

export default ResumoFormularioPeticao